/* eslint-disable no-unused-vars */
import Types from "./types";
import { LeadServiceJava } from "../../../service/lead-service-java-api";
import { VehicleService } from "../../../service/vehicle-service";
import { NewCarCmsServiceApi } from "../../../service/new-car-cms-service";
import { parseNewCmsData } from "../../../utils/helpers/new-cms-data-parser";

const setLeadDetails = (leadDetails) => ({
    type: Types.SET_LEAD_DETAILS,
    leadDetails
});
const setScrapCarContent = (data) => ({
    type: Types.SET_SCRAP_DATA_SUCCESS,
    data
});
const setShowAnimation = (showAnimation) => ({
    type: Types.SET_SHOW_ANIMATION,
    showAnimation
});

const fetchLeadDetails = (token, params, secureToken) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.fetchLeadDetailsProtected(token, params, false, secureToken).then(response => {
            dispatch(setLeadDetails(response.data.detail));
            resolve(response.data.detail);
        }).catch(error => {
            reject(error);
        });
    });
};

const fetchScrapCarQuestions = () => dispatch => {
    return new Promise((resolve, reject) => {
        VehicleService.getScrapCarQuestions().then(response => {
            resolve(response.data.detail.questions);
        }).catch(error => {
            reject(error);
        });
    });
};

const saveScrapCarQuestion = (payload) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.saveScrapCarQuestion(payload).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const fetchScrapCarContent = (payload) => dispatch => {
    return new Promise((resolve, reject) => {
        NewCarCmsServiceApi.fetchScrapCarContent(payload).then(response => {
            dispatch(setScrapCarContent(parseNewCmsData({data: response.data.data, isMobile: false})));
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

export {
    fetchLeadDetails,
    fetchScrapCarQuestions,
    saveScrapCarQuestion,
    fetchScrapCarContent,
    setShowAnimation
};
